<template>
  <v-container>
    <v-layout row wrap fill-height class="mt-1">
      <v-flex d-flex xs12 sm4>
        <v-card dark color="primary" height="400" class="hero-card pa-3">
          <v-card-title>
            <h1>Welcome To HUIREP</h1>
          </v-card-title>
          <v-card-actions class="ml-2">
            <v-btn depressed="" color="accent" to="/auth/login">
              <v-icon small class="mr-1">lock_open</v-icon>
              Login
            </v-btn>
            <v-btn depressed="" color="accent" to="/auth/register">
              <v-icon small class="mr-1">layers</v-icon>
              Partner Sign Up
            </v-btn>
          </v-card-actions>
          <v-card-text>
            The Humanitarian Intervention Repository (HUIREP) provides a way for Government, partners and other stakeholders to access and share timely relevant information related to Humanitarian interventions across pilot States.
          </v-card-text>
          <v-card-text>
            HUIREP provides the relevant information necessary to make quick and effective decisions about where a crisis has occurred, what has been done and what needs remain. It is managed by State Emergency Management Agencies with support from the National Emergency Management Agency of Nigeria.
          </v-card-text>
          <v-card-text>
            This database is powered by Christian Aid with support from Start Fund and in partnership with the National Emergency Management Agency of Nigeria.
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm8 class="text-xs-center">
        <v-carousel progress show-arrows-on-hover hide-delimiters height="400" class="hero-carousel">
          <v-carousel-item v-for="(item, i) in carouselItems" :key="i" :src="item.src"></v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>

    <v-layout row wrap align-center class="partners white py-4 mt-5">
      <!-- <v-flex xs12 class="text-xs-center mb-4">
        <h2>Our Partners</h2>
      </v-flex> -->
      <v-flex xs12 sm3 class="text-xs-center" v-for="(partner, index) in partners" :key="index">
        <img :class="`partner-logo ${partner.class}`" :src="partner.logo" alt="Christian Aid Logo">
      </v-flex>
    </v-layout>

    <MainFooter />
  </v-container>
</template>

<script>
import MainFooter from '@/components/Footer/MainFooter.vue'

import CarouselImage1 from '@/assets/images/falmata-bulama-1711993L.jpg'
import CarouselImage2 from '@/assets/images/samira-daniel-1712041L.jpg'
import ChristianAidLogo from '@/assets/images/christian-aid-logo.svg'
import StartNetworkLogo from '@/assets/images/start-network-logo.png'
import CoatOfArms from '@/assets/images/nigeria-coat-of-arms.jpg'
import NemaLogo from '@/assets/images/nema-logo.png'

export default {
  name: 'Home',
  components: {
    MainFooter
  },
  data () {
    return {
      carouselItems: [
        { title: '', src: CarouselImage1 },
        { title: '', src: CarouselImage2 }
      ],
      partners: [
        { name: 'Christian Aid', logo: ChristianAidLogo, class: 'christian-aid' },
        { name: 'Start Network', logo: StartNetworkLogo, class: 'start-network' },
        { name: 'Nigerian Government', logo: CoatOfArms, class: 'coat-of-arms' },
        { name: 'NEMA', logo: NemaLogo, class: 'nema' }
      ]
    }
  }
}
</script>

<style scoped>
.hero-card {
  border-radius: 0;
  /* border: 4px solid #152031 !important; */
  overflow: auto
}

.hero-carousel {
  box-shadow: none !important
}

.partners {
  border-top: 4px solid #eaeaea !important;
  border-bottom: 4px solid #eaeaea !important;
}

.partner-logo {
  width: 100%;
  max-width: 120px;
}

.partner-logo.start-network {
  max-width: 150px
}

.partner-logo.coat-of-arms {
  max-width: 70px
}

.partner-logo.nema {
  max-width: 80px
}
</style>
